import type { ZoneStat } from './playerPerformanceUtils';

export enum CornerKicksInsightScoreType {
  Good = 'Good',
  Average = 'Average',
  Bad = 'Bad',
  None = 'None',
}

export const GOOD_SCORE_COLOR = '#22C55E';
export const MEDIUM_SCORE_COLOR = '#EED202';
export const POOR_SCORE_COLOR = '#DC2626';
export const NO_SCORE_COLOR = '#7B7B7B';

/**
 * Mirrors CornerKicksInsightHelpers.EvaluateScore semantics from C#:
 * - None: score missing or kicks == 0
 * - Bad: score < 0.2
 * - Good: score > 0.51
 * - Average: otherwise
 */
export function evaluateCornerKicksScoreType(
  kicks: number,
  score: number | null | undefined,
): CornerKicksInsightScoreType {
  if (score == null || kicks === 0) return CornerKicksInsightScoreType.None;
  if (score < 0.2) return CornerKicksInsightScoreType.Bad;
  if (score > 0.51) return CornerKicksInsightScoreType.Good;
  return CornerKicksInsightScoreType.Average;
}

export function colorForCornerKicksScoreType(scoreType: CornerKicksInsightScoreType): string {
  switch (scoreType) {
    case CornerKicksInsightScoreType.Good:
      return GOOD_SCORE_COLOR;
    case CornerKicksInsightScoreType.Average:
      return MEDIUM_SCORE_COLOR;
    case CornerKicksInsightScoreType.Bad:
      return POOR_SCORE_COLOR;
    case CornerKicksInsightScoreType.None:
      return NO_SCORE_COLOR;
    default:
      return NO_SCORE_COLOR;
  }
}

/**
 * Converts the existing ZoneStat shape to score type + color.
 * ZoneStat.onTargetPct is in 0..100; helper evaluation expects 0..1.
 */
export function zoneColorFromStat(stat: ZoneStat | undefined): string {
  if (!stat) return NO_SCORE_COLOR;
  const score01 = stat.onTargetPct == null ? null : stat.onTargetPct / 100;
  const scoreType = evaluateCornerKicksScoreType(stat.kickCount, score01);
  return colorForCornerKicksScoreType(scoreType);
}
